import React, {PropsWithChildren} from "react";
import {t} from "i18next";

export const RemoveFilterButton: React.FC<PropsWithChildren<{onCancel: () => void; className?: string}>> = ({
  children,
  className,
  onCancel,
}) => (
  <button className={["filter-remove__button", className].join(" ")} onClick={onCancel}>
    <span className="visually-hidden">{`${t("general.remove")} ${t("product.filterBy")}`}</span>
    {children}
    <span className="icon icon-close" />
  </button>
);
